import { fetchWithApiKey } from "../../helpers/fetch";
import { types } from "../../types/types";

export const professionTypesStartLoading = () => {
  return async(dispatch) => {
    const resp = await fetchWithApiKey('api/Catalogs/c_Profession');
    const body = await resp.json();
    if (body.success){
      dispatch( professionTypesLoaded( body.data ) )
    }
  }
}

const professionTypesLoaded = (professions) => ({
  type: types.professionsStartLoading,
  payload: professions
})
